import {useEffect} from "react";
import {setTimeZoneId} from "../slices/restaurantSlice";
import {useDispatch, useSelector} from "react-redux";
import {useTimeZoneIds} from "./useTimeZoneIds";

export const useTimeZoneDetection = () => {
    const dispatch = useDispatch();
    const {settings} = useSelector(state => state.restaurant.form);
    const timeZoneOptions = useTimeZoneIds();

    useEffect(() => {
        if (settings.timeZoneId || !timeZoneOptions.length) return;

        const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const matchedTimeZone = timeZoneOptions.find(
            option => option.value === browserTimeZone
        );

        if (matchedTimeZone) {
            dispatch(setTimeZoneId(matchedTimeZone));
        }
    }, [dispatch, settings.timeZoneId, timeZoneOptions]);

    return null;
}